import styled from '@emotion/styled';
import { Topbar } from 'components/topbar';
import { Sidebar } from 'components/sidebar';

export const Layout = ({
  children,
  iframe = false,
}: {
  children: React.ReactNode;
  iframe: boolean;
}) => {
  return (
    <LayoutWrapper>
      <Sidebar>
        <Topbar />
        <main>{children}</main>
      </Sidebar>
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;

  main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${p => p?.theme.palette.bg.secondary};
    padding: 24px;
    height: ${p => (p?.noPadding ? '100vh' : 'calc(100vh - 96px)')};
    overflow-x: hidden;
    overflow-y: hidden;
    ${p => (p?.noPadding ? 'padding-right: 0; padding-top: 0;' : '')}
  }
`;
